module.exports = __webpack_public_path__ + "img/page12.ed4a2f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tax/page12.png
// module id = NYTc
// module chunks = 0